import React from 'react';
import {darkModeWebContent, themeOverrides, view} from '@sail/ui';
import {useSelector} from 'src/v2/state/store';
import {getThemeParam} from 'src/utils/utils';

export const ThemeProvider = ({children}: {children: React.ReactNode}) => {
  const darkModeEnabled = useSelector(
    (state) => state.featureFlags.enable_crypto_payins_dark_mode,
  );

  const themeParam = getThemeParam();
  const themeUses = darkModeEnabled
    ? [themeParam === null ? darkModeWebContent() : themeOverrides(themeParam)]
    : [];

  return (
    <view.div uses={themeUses} css={{backgroundColor: 'surface'}}>
      {children}
    </view.div>
  );
};
